import { createStore } from 'satcheljs';
export default createStore('messagePreviewOption', {
    showPreviewTextInListView: null,
})();
//# sourceMappingURL=store.js.map